import React from 'react';
import { useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import 'react-toastify/dist/ReactToastify.css';
import AccountsFormComponents from 'src/components/accounts/AccountsFormComponents';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';

const urlApi = '/app_personal_accounts';

export async function LoaderAccountsUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => {
      return response;
    }).catch(err => {
      console.log(err)
    })
    return res;
  }
  return false;
};

const AccountsForm = ({ user_data }) => {

  // if (!Permissions(user_data, 'Accounts', 'EDIT_ACCOUNTS')) {
  //   return <PermissionsNoPage />;
  // }
  const { data } = useLoaderData();

  return (
    <AccountsFormComponents data={data} type="accountPage" />
  );

};

export default AccountsForm;
